import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

import { Logo } from '@client/toolkit';

import { PortfolioPaths } from '../../portfolio.router';
import { BuildingWizardStepper } from './building-wizard-stepper';

interface BuildingWizardLayoutProps {
  currentStep: number;
}

/**
 * Full-screen layout for the in-tenant "Create building" wizard. Mirrors
 * <c>OnboardingLayout</c> visually but adds a close (×) button that returns to
 * the building list, since this flow is not invitation-gated and must be cancelable.
 */
export function BuildingWizardLayout({
  currentStep,
  children,
}: PropsWithChildren<BuildingWizardLayoutProps>) {
  const navigate = useNavigate();

  // z-30: above the app chrome (navbar is z-10) but below toolkit modals (z-40),
  // so dialogs opened from wizard steps — e.g. the manual BuildingForm — stay visible.
  return (
    <div className="fixed inset-0 z-30 bg-background flex flex-col overflow-y-auto">
      <div className="relative flex justify-center pt-8 pb-4">
        <Logo className="w-16 h-16" />
        <button
          type="button"
          aria-label="Avbryt og gå tilbake"
          className="absolute right-6 top-6 w-10 h-10 rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 flex items-center justify-center transition-colors"
          onClick={() => navigate(PortfolioPaths.BuildingList)}
        >
          <FaTimes />
        </button>
      </div>

      <div className="px-4 py-4">
        <BuildingWizardStepper currentStep={currentStep} />
      </div>

      <div className="flex-1 flex flex-col items-center px-4 pb-12">
        <div className="w-full max-w-2xl">{children}</div>
      </div>
    </div>
  );
}
